module.exports = __webpack_public_path__ + "img/GiulioX.506ea101.jpg";